import { lightTheme } from './light'
import { darkTheme } from './dark'

const theme = {
	light	: darkTheme,
	dark		: darkTheme
}

export default theme